// import awords from "../../image/AWARDS.jpg"
import awords1 from "../image/award1 (1).webp";
// import Abanner from "../image/Award (2).jpeg";
// import Abanner1 from "../image/Award (3).jpeg";
import aword1 from "../image/award (1).webp";
import awords2 from "../image/award (2).webp";
import awords3 from "../image/award (3).webp"
import awords4 from "../image/award (4).webp";
import awords5 from "../image/award (5).webp";
import awords6 from "../image/award (6).webp";
import awords7 from "../image/award (7).webp";
import awords8 from "../image/award (8).webp";
import awords9 from "../image/award (9).webp";
import awords10 from "../image/award (10).webp";
import awords11 from "../image/award (11).webp"
import awords12 from "../image/award (12).webp";
import awords13 from "../image/award (13).webp";
import awords14 from "../image/award (14).webp";
import awords15 from "../image/award (15).webp";
import awords16 from "../image/award (16).webp";
import awords17 from "../image/award (17).webp";
import awords18 from "../image/award (18).webp"
import awords19 from "../image/award (19).webp"

export const AwardData = [
  // {
  //     id:1,
  //     url: awords1,
  //     title: " Excellence Karnataka Award 2026",
  //     description: "Innovation in Consumer Electronics & Smart Lifestyle Solutions.",
  //     date: "Jan 2025",
  // },
  {
    id: 2,
    url: [awords1],
    title: " Karnataka Excellence Award 2026 Innovation in Consumer Electronics",
    description:
      "This prestigious Certificate of Excellence is awarded by the National Excellence Council to Garuda Mart India Pvt Ltd for its outstanding innovation and impactful contributions in the field of consumer electronics and smart lifestyle solutions. The recognition highlights the visionary leadership of Mr. Venkataramana and the company’s commitment to delivering cutting-edge technology, quality products, and modern living solutions. This achievement sets a benchmark of excellence and reinforces the brand’s position as an industry leader.",
    
  },
  {
    id: 3,
    url: awords7,
    title: "Top 30 Business Leaders of the Year 2023",
    description: "This distinguished award was presented to Mr. R. Venkataramana, Chairman & Managing Director of Garuda Mart India Pvt. Ltd., in recognition of his exceptional leadership and contribution to business excellence. Being named among the Top 30 Business Leaders of 2023 highlights his vision, innovation, and impactful role in driving organizational growth and industry advancement. This honor reflects a commitment to leadership excellence and entrepreneurial success.",
    
  },
  {
    id: 4,
    url: awords19,
    title: "Top 30 Business Leaders of the Year 2023 Certificate of Achievement",
    description: "This distinguished certificate honors Mr. R. Venkataramana, Chairman & Managing Director of Garuda Mart India Pvt. Ltd., for being recognized among the Top 30 Business Leaders of 2023. Presented by The Indian Alert, the award celebrates exceptional leadership, business excellence, and impactful contributions to the corporate sector. The plaque features an ornate gold design on a wooden base, highlighting its prestige, along with media recognition from prominent platforms.",
    
  },
  {
    id: 5,
    url: awords16,
    title: "JAS World Signature Awards Trophy 2023",
    description: "A striking black trophy featuring a stylized human figure with arms raised in triumph, holding the “JAS” lettering overhead. Mounted on a sturdy round base with a detailed plaque, this award represents achievement, recognition, and excellence at the World Signature Awards 2023. Its bold, modern design symbolizes ambition, success, and the celebration of outstanding accomplishments.",

  },
  {
    id: 6,
    url: awords15,
    title: "India Excellence Award Trophy 2022",
    description: "A sleek and elegant award trophy featuring a golden star encased within a circular frame, mounted on a tall black column with metallic accents. The base displays the inscription “Blindwink India Excellence Awards 2022,” symbolizing recognition for outstanding achievement and excellence. The modern design and polished finish make it a prestigious emblem of success and honor.",
    
  },
  {
    id: 7,
    url: [aword1],
    title: "India Trade Awards 2022 Business Excellence in Manufacturing",
    description: "This prestigious award, presented by Asian Arab Trade Chamber of Commerce (AATCOC), recognizes Garuda Mart India Pvt Ltd for outstanding performance and excellence in the manufacturing sector. The company was honored under the category of Business Excellence in Manufacturing of Consumer Electronics, highlighting its commitment to innovation, quality, and industry leadership. This achievement reflects the brand’s dedication to delivering advanced and reliable consumer solutions in the Indian market.",
    
  },
  {
    id: 8,
    url: awords8,
    title: "India Excellence Awards 2022 Best Innovative Consumer Products",
    description: "This prestigious award was presented to Garuda Mart India Pvt. Ltd. at the India Excellence Awards 2022 for delivering innovative consumer products within an economic range. The recognition highlights the company’s commitment to affordability, innovation, and quality, making impactful products accessible to a wider audience. It reflects excellence in product development and a strong focus on customer-centric solutions..",
    
  },
   
  {
    id: 9,
    url: awords11,
    title: "Indian Achievers’ Award 2021–22 for Excellence in Manufacturing",
    description: "This framed award recognizes R. Venkataramana, Chairman & Managing Director of Garuda Mart India Pvt. Ltd., for outstanding excellence in the manufacturing sector. Presented by the Indian Achievers’ Forum for the year 2021–22, it honors exceptional professional achievement and valuable contributions toward nation-building. The elegant plaque features a black and gold design with official signatures and the forum’s emblem, symbolizing prestige and recognition in the industry.",
    
  },
  {
    id: 10,
    url: awords6,
    title: "Indian Achievers’ Award 2021–22 Excellence in Manufacturing",
    description: "This prestigious recognition was awarded to R. Venkataramana, Chairman & Managing Director of Garuda Mart India Pvt. Ltd., for outstanding excellence in the manufacturing sector. Presented at the Indian Achievers’ Award 2021–22, this honor celebrates leadership, innovation, and consistent contribution to industrial growth. It reflects a strong commitment to quality, operational excellence, and impactful business practices.",
    
  },
 
  
  
  
  
 
  {
    id: 11,
    url: awords12,
    title: "India Trade Awards 2022 Excellence in Manufacturing",
    description: "This elegant trophy celebrates Garuda Mart India Pvt. Ltd. for outstanding performance in the manufacturing sector at the India Trade Awards 2022, presented by Indian Journo. Recognizing business excellence and innovation, the award highlights the company’s contribution to customer satisfaction and industry growth. The sleek, modern design features a combination of clear and blue glass with a circular emblem, mounted on a sturdy base, symbolizing achievement and prestige.",
    
  },
  {
    id: 12,
    url: awords2,
    title: "India 5000 Best MSME Awards 2021 Certificate of Recognition",
    description: "This prestigious Certificate of Recognition is awarded to Garuda Mart India Pvt. Ltd. as a 2021 winner of the India 5000 Best MSME Awards for excellence in quality and customer satisfaction. The award highlights the company’s outstanding contribution to service, management, and societal impact. Issued by Benchmark Trust in association with TQV Certification Services and BSE SME, this framed certificate symbolizes credibility, achievement, and commitment to excellence in the MSME sector.",
    
  },
  {
    id: 13,
    url: awords3,
    title: "National Achievers Award for Business Excellence 2021",
    description: "This distinguished award plaque honors Sh. R. Venkataramana, Managing Director of Garuda Mart India Pvt. Ltd., for exceptional leadership and business performance. Presented by the National Achievers Recognition Forum, the National Achievers Award for Business Excellence 2021 recognizes outstanding contributions to industry growth, innovation, and excellence. The ornate design and medal accent reflect prestige, credibility, and a commitment to achieving high standards in business.",
    
  },
  {
    id: 14,
    url: awords9,
    title: "National Achievers Award for Business Excellence 2021",
    description: "Garuda Mart India Pvt. Ltd. proudly receives the National Achievers Award for Business Excellence 2021, honoring exceptional performance, visionary leadership, and significant contribution to industry growth. This prestigious recognition highlights the company’s commitment to quality, innovation, and excellence on a national and global scale.",
    
  },
  {
    id: 15,
    url: awords13,
    title: "Award for Quality Excellence India 5000 MSME Awards",
    description: "Winner of India 5000 Best MSME Awards 2021 for excellence in quality, innovation, and business performance..",
    
  },
   {
    id: 16,
    url: awords10,
    title: "India 500 Startup Awards 2020 Certificate of Recognition",
    description: "Garuda Mart India Pvt. Ltd. has been honored with the prestigious India 500 Startup Awards 2020, recognizing outstanding contribution in quality, customer satisfaction, and business excellence. This achievement reflects the company’s dedication to innovation, superior service, and impactful growth in the industry.",
    
  },
  {
    id: 17,
    url: awords17,
    title: "India 500 CEO Awards 2020 Certificate of Recognition",
    description: "A formal Certificate of Recognition presented under the India 500 CEO Awards 2020, elegantly displayed in a sleek black frame. The certificate honors Mr. R. Venkataramana for outstanding contributions to quality, excellence, and customer satisfaction, highlighting impactful leadership and service. Featuring official signatures, a seal, and refined typography, it represents prestige and professional achievement.",
    
  },
   {
    id: 18,
    url: awords4,
    title:
      "Biznex Award of Excellence 2019",
    description: "This prestigious award recognizes outstanding contribution and dedication to social impact. Presented at the Biznex Business Networking Expo 2019, this honor was awarded to Sri Venkata Ramana for his exemplary work as an eminent social activist and his commitment to making a positive difference in society. The event was held at NSIC Business Park, ECIL, Hyderabad, celebrating individuals who inspire change and lead with integrity.",
    
  },
  {
    id: 19,
    url: awords5,
    title: "Indian Business Awards 2019 Certificate of Achievement",
    description: "This Certificate of Achievement was awarded to Mr. Venkata Raman of Garudamart India Pvt. Ltd. in recognition of outstanding performance and innovation in product manufacturing. Honored at the Indian Business Awards 2019, this accolade celebrates excellence in business innovation and acknowledges remarkable contributions evaluated among thousands of nominations. The award highlights a commitment to quality, innovation, and industry leadership.",
    
  },
//   {
//     id: 19,
//     url: awords13,
//     title: "Award for Quality Excellence India 5000 MSME Awards",
//     description: "Winner of India 5000 Best MSME Awards 2021 for excellence in quality, innovation, and business performance..",
    
//   },
  {
    id: 20,
    url: awords14,
    title: "Recognition for Excellence Indian Cooperative Credit Society Ltd.",
    description: "Cooperative Credit Society Ltd. (ICCS) for outstanding leadership, dedication, and contribution to the cooperative and financial sector. This award reflects the company’s commitment to excellence, trust, and impactful service in driving organizational growth and community development.",

  },
  
  
  
  {
    id: 21,
    url: awords18,
    title: "Certificate of Appreciation for Outstanding Contribution",
    description: "This elegant certificate of appreciation, presented by Ward Wizard, recognizes Garudamart India Pvt. Ltd. for their continuous efforts and valuable contribution toward growth throughout the year. Framed in a decorative, silver-toned border, the award reflects gratitude and acknowledgment of dedication, hard work, and partnership. Signed by CEO & Founder Mr. Yatin Gupte, it conveys best wishes for continued success in the future.",
    
  },
  
  
];
